import React from 'react';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import iconClose from '../../../images/icon-close.svg';
import { removeLocation } from '../../../redux/location/actions/location.action';
import { AppDispatch } from '../../../redux/rootReducer';
import { deleteUnits } from '../../../redux/units/actions/units.action';
import styles from './RemoveModal.module.css';
import { Controller, useForm } from 'react-hook-form';
import TextInput from '../input/textInput/TextInput';

const RemoveModal = ({ setDeletePopup, unitId, type, setUnitsData, unitsData, locationId, onDeleteSuccess }: AnyIfEmpty<object>) => {
    const { id } = useParams();

    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();

    const closeModal = () => setDeletePopup(false);

    const { control, handleSubmit, watch } = useForm({
        defaultValues: {
            reason: '',
        },
    });

    const deleteUnitHandler = async (data: { reason: string }) => {
        if (id && data?.reason) {
            try {
                await dispatch(deleteUnits(unitId, id, data.reason, locationId, navigate));
                setDeletePopup(false);
                await onDeleteSuccess();
            } catch (error) {
                console.error("Failed to delete unit:", error);
            }
        }
    };

    const deletePropertyHandler = async () => {
        dispatch(removeLocation(unitId, navigate));
        setDeletePopup(false);

        // const findIndex = unitsData.findIndex((unit: Element) => unit.id === unitId);
        // unitsData.splice(findIndex, 1);
        // setUnitsData(unitsData);
    };

    const reason = watch('reason');

    return (
        <>
            <div className={styles.modalRemoveStaff}>
                {type === 'Unit' ? (
                    <form onSubmit={handleSubmit(deleteUnitHandler)}>
                        <div className={styles.modalHeader}>
                            <div className={styles.modalTitle}>Delete {type}</div>
                            <span className={styles.close}>
                                <img src={iconClose} onClick={closeModal} alt="Close" />
                            </span>
                        </div>

                        <div className={styles.modalBody}>
                            <div>
                                <h2 className={styles.modalBodyTitle}>Are you sure you want to delete this unit?</h2>
                                <p className={styles.modalBodyInfo}>Units cannot be recovered once deleted.</p>
                            </div>

                            <div className={styles.reasonInput}>
                                <Controller
                                    name="reason"
                                    control={control}
                                    render={({ field }) => (
                                        <TextInput
                                            {...field}
                                            autoFocus
                                            type="text"
                                            id="reason"
                                            placeholder="Enter reason for deleting this unit"
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={styles.modalFooter}>
                            <button onClick={closeModal} className={`${styles.Modalbtn} ${styles.cancelBtn}`}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={!(reason && reason.trim() !== '')}
                                className={`${styles.Modalbtn} ${styles.deleteBtn}`}>
                                Delete
                            </button>
                        </div>
                    </form>
                ) : (
                    <>
                        <div className={styles.modalHeader}>
                            <div className={styles.modalTitle}>Delete {type}</div>
                            <span className={styles.close}>
                                <img src={iconClose} onClick={closeModal} alt="Close" />
                            </span>
                        </div>

                        <div className={styles.modalBody}>
                            <div>
                                <h2 className={styles.modalBodyTitle}>Are you sure you want to delete this property?</h2>
                                <p className={styles.modalBodyInfo}>Properties cannot be recovered once deleted.</p>
                            </div>
                        </div>

                        <div className={styles.modalFooter}>
                            <button onClick={closeModal} className={`${styles.Modalbtn} ${styles.cancelBtn}`}>
                                Cancel
                            </button>
                            <button type="submit" onClick={deletePropertyHandler} className={`${styles.Modalbtn} ${styles.deleteBtn}`}>
                                Delete
                            </button>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default RemoveModal;
